export default __webpack_public_path__ + "static/media/agentactivity.4a0e368a.svg";